import { render, staticRenderFns } from "./PlansComponent.vue?vue&type=template&id=72636469&scoped=true"
import script from "./PlansComponent.vue?vue&type=script&lang=js"
export * from "./PlansComponent.vue?vue&type=script&lang=js"
import style0 from "./PlansComponent.vue?vue&type=style&index=0&id=72636469&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72636469",
  null
  
)

export default component.exports